import domReady from '@wordpress/dom-ready';
import manifest from './../manifest.json';

domReady(async () => {
	const blockSelector = `.js-block-${manifest.blockName}`;
	const itemSelector = `.js-complex-auto-accordion-item`;
	const accordionElements = document.querySelectorAll(blockSelector);

	if (!accordionElements.length) {
		return;
	}

	const { ComplexAutoAccordion } = await import('./complex-auto-accordion');

	[...accordionElements].forEach((item) => {
		const accordion = new ComplexAutoAccordion({
			accordion: item,
			blockSelector,
			itemSelector,
			triggerSelector: `${itemSelector}-trigger`,
			panelSelector: `${itemSelector}-panel`,
			progressbarSelector: `${itemSelector}-progressbar`,
			itemImageSelector: `${itemSelector}-image`,
			itemImageBackplateSelector: `${itemSelector}-image-backplate`,
			imageSelector: `${blockSelector}-image`,
			secondImageSelector: `${blockSelector}-second-image`,
			imageBackplateSelector: `${blockSelector}-image-backplate`,
		});

		accordion.init();
	});
});
